import { Styles } from '@types'
import dayjs, { Dayjs } from 'dayjs'
import { AccessLogSearch } from 'gadjet-v2-types/dist/type/search'
import { RangeValue } from 'rc-picker/lib/interface'
import { useMemo } from 'react'

import LocalDatePicker from '@components/atoms/LocalDatePicker'
import SearchBox from '@components/molecules/SearchBox'
import SearchItem from '@components/molecules/SearchItem'

type Props = {
  search: AccessLogSearch
  onChangeSearch: (search: Partial<AccessLogSearch>) => void
  onSearch: () => void
}

export default function BranchAccessLogSearchBox({ search, onChangeSearch, onSearch }: Props): JSX.Element {
  const onChangeDateRange = (_value: RangeValue<Dayjs>) => {
    const start = _value?.[0]?.format('YYYY-MM-DD') || search.datetime[0]
    const end = _value?.[1]?.format('YYYY-MM-DD') || search.datetime[1]
    onChangeSearch({ datetime: [start, end] })
  }

  const rangeValue = useMemo((): [Dayjs, Dayjs] => {
    const [start, end] = search.datetime
    return [dayjs(start), dayjs(end)]
  }, [search])
  return (
    <SearchBox onSearch={onSearch}>
      <SearchItem label="날짜" span={6}>
        <LocalDatePicker.RangePicker
          size="large"
          style={styles.datePicker}
          value={rangeValue}
          onChange={onChangeDateRange}
        />
      </SearchItem>
    </SearchBox>
  )
}

const styles: Styles = {
  datePicker: { width: '100%' },
  select: { width: '100%' },
}
